import { BMEventsType } from '../types';

const makeFeatureFlags = (allFeatureFlags, eventTypeFeatureFlags) => {
  const featureFlagsForType = [];

  if (allFeatureFlags) {
    featureFlagsForType.push(...allFeatureFlags);
  }

  if (eventTypeFeatureFlags) {
    featureFlagsForType.push(...eventTypeFeatureFlags);
  }

  return featureFlagsForType;
};

const makeGlobalConfigPerType = (global, ffClient, allEventsConfig, eventConfig) => {
  const allEventsConfigCustom = allEventsConfig && allEventsConfig.custom;
  const eventConfigCustom = eventConfig && eventConfig.custom;
  const custom = (allEventsConfigCustom || eventConfigCustom) && { ...allEventsConfigCustom,
    ...eventConfigCustom
  } || undefined;
  const allEventsConfigPlugins = allEventsConfig && allEventsConfig.plugins;
  const eventConfigPlugins = eventConfig && eventConfig.plugins;
  const plugins = (allEventsConfigPlugins || eventConfigPlugins) && [...(allEventsConfigPlugins || []), ...(eventConfigPlugins || [])] || undefined;
  return Object.freeze({ ...global,
    featureFlags: Object.freeze(makeFeatureFlags(allEventsConfig && allEventsConfig.featureFlags, eventConfig && eventConfig.featureFlags).reduce((acc, value) => {
      acc[value] = ffClient.getValue(value);
      return acc;
    }, {})),
    custom,
    plugins,
    histogram: eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.histogram
  });
};

export const makeShareableGlobalConfig = async globalConfig => {
  var _globalConfig$events$, _globalConfig$events$2;

  const ffClient = await globalConfig.plugins.featureFlags.client;
  const global = {
    app: globalConfig.info.app,
    product: globalConfig.info.product,
    region: globalConfig.info.region,
    resourceTimings: globalConfig.plugins.resourceTimings,
    bundleEvalTimings: globalConfig.plugins.bundleEvalTimings,
    ffClient,
    hostname: globalConfig.info.hostname || window.location.hostname,
    ssr: globalConfig.ssr,
    webVitals: {
      enabled: (_globalConfig$events$ = globalConfig.events[BMEventsType.WEB_VITALS]) === null || _globalConfig$events$ === void 0 ? void 0 : _globalConfig$events$.enabled,
      timeout: (_globalConfig$events$2 = globalConfig.events[BMEventsType.WEB_VITALS]) === null || _globalConfig$events$2 === void 0 ? void 0 : _globalConfig$events$2.timeout
    }
  };
  return {
    [BMEventsType.PAGE_LOAD]: makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[BMEventsType.PAGE_LOAD]),
    [BMEventsType.PAGE_SEGMENT_LOAD]: makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[BMEventsType.PAGE_SEGMENT_LOAD]),
    [BMEventsType.INLINE_RESULT]: makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[BMEventsType.INLINE_RESULT]),
    [BMEventsType.CUSTOM]: makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[BMEventsType.CUSTOM]),
    [BMEventsType.WEB_VITALS]: makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[BMEventsType.WEB_VITALS])
  };
};